<template>
  <div class="position-relative w-100"  :style="{ zIndex: isFocus ? 1000 : 1 }">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      :state="state"
      :value="query || displayText"
      @input="onSearchInput"
      :placeholder="placeholderText"
      autocomplete="off"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <div class="select-input-body-wrapper">
      <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
        <v-icon v-if="selectedItems.length > 0 && !isFocus" name="buttons/cross" :size="11"/>
        <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
        <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
      </button>
    </div>

    <div v-if="isFocus" class="custom-dropdown-select" :class="{ 'drop-up': dropUp }">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="checkItem(item)"
        >
          <b-form-checkbox
            :checked="isSelected(item.id)"
            class="text-small m-0"
            style="pointer-events: none;"
          >
            {{ item.name }}
          </b-form-checkbox>
        </div>
      </div>

      <div v-if="filteredItems.length > 0 && canCreateCatalog" class="custom-dropdown-select-footer p-1 border-top">
        <b-btn class="custom-btn-primary mt-0" :disabled="isDisabled" @mousedown.prevent="showModalCatalog">
          <v-icon name="buttons/plus" :size="12"/>
          Добавить {{ catalogName }}
        </b-btn>
      </div>

      <div v-if="filteredItems.length === 0 && query" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
        <b-btn v-if="canCreateCatalog" class="custom-btn-primary mt-2" :disabled="isDisabled" @mousedown.prevent="showModalCatalog">
          <v-icon name="buttons/plus" :size="12"/>
          Добавить {{ catalogName }}
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CatalogMultiSelect",
  props: {
    isDisabled: { type: Boolean, default: false },
    state: { type: Boolean, default: null },
    initialValue: { type: Array, default: () => [] },
    catalogName: { type: String, required: true },
    getList: { type: Function, required: true },
    canCreateCatalog: { type: Boolean, default: false },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      selectedItems: [],
    }
  },
  computed: {
    filteredItems() {
      const query = this.query ? this.query.trim().toLowerCase() : '';
      if (!query) return this.items;
      return this.items.filter(item => item.name.toLowerCase().includes(query));
    },
    displayText() {
      if (this.selectedItems.length === 0) return "";

      const names = this.selectedItems.map(i => i.name);
      if (names.length <= 3) return names.join(", ");
      return `Выбрано: ${names.length}`;
    },
    placeholderText() {
      if (this.items.length === 0) return `Создайте ${this.catalogName}`;
      return `Выберите ${this.catalogName}`;
    }
  },
  watch: {
    initialValue: {
      handler(newValue) {
        if (!Array.isArray(newValue) || this.items.length === 0) return;
        this.selectedItems = this.items.filter(item => newValue.includes(item.id));
      }, immediate: true
    },
    items: {
      handler() {
        if (!Array.isArray(this.initialValue) || this.items.length === 0) return;
        this.selectedItems = this.items.filter(item => this.initialValue.includes(item.id));
      }
    }
  },
  mounted() {
    this.getItems();
  },
  methods: {
    async getItems() {
      this.items = await this.getList() || [];
    },
    isSelected(id) {
      return this.selectedItems.some(item => item.id === id);
    },
    onSearchInput(value) {
      this.query = value;
    },
    onFocusIn() {
      this.isFocus = true;
      this.query = '';
    },
    onFocusOut() {
      this.isFocus = false;
      this.query = '';
    },
    onClick() {
      if (this.selectedItems.length > 0 && !this.isFocus) {
        this.onClear();
      } else {
        this.isFocus ? this.onFocusOut() : this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    checkItem(item) {
      const index = this.selectedItems.findIndex(i => i.id === item.id);
      if (index > -1) {
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(item);
      }
      this.onSelect();
      this.$refs.input_ref.$el.focus();
    },
    onClear() {
      this.query = '';
      this.selectedItems = [];
      this.onSelect();
    },
    onSelect() {
      const ids = this.selectedItems.map(i => i.id);
      this.$emit('onSelect', ids);
    },
    showModalCatalog() {
      this.isFocus = false;
      this.$emit('open-modal');
    },
    onItemCreated(newItem) {
      this.items.push(newItem);
      this.selectedItems.push(newItem);
      this.onSelect();
    }
  }
}
</script>

<style scoped>
.custom-dropdown-select-item b-form-checkbox {
  pointer-events: none;
}

.custom-dropdown-select.drop-up {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/CatalogMultiSelect.vue